// Compatibilidade Guid (string) ↔ ids numéricos legados.
// Backend retorna Guid (e.g. "0d8708ef-..."). UI legada usava Number().
// Comparar sempre como string evita NaN.

export function idsIguais(a, b) {
  if (a === undefined || a === null || a === "") return false;
  if (b === undefined || b === null || b === "") return false;
  return String(a) === String(b);
}

export function normalizarId(v) {
  if (v === undefined || v === null) return null;
  return String(v);
}

// Lê usuário do localStorage e adapta para shape esperado pela UI legada.
export function getUsuarioLogadoAdaptado() {
  try {
    const u = JSON.parse(localStorage.getItem("usuario") || "null");
    if (!u) return null;
    return {
      ...u,
      faculdadeId: u.faculdadeId || u.instituicaoId,
      instituicaoId: u.instituicaoId || u.faculdadeId,
      tipo: String(u.tipo || "").toLowerCase(),
    };
  } catch {
    return null;
  }
}
